import styled from "@emotion/styled";
import { DESKTOP, lnbAndFloating } from "@/themes/device";
import { grayScale } from "@teamsparta/design-system";

export const Background = styled.div<{ isWhite: boolean }>`
  height: 50px;
  background-color: ${({ isWhite }) =>
    isWhite ? "white" : `${grayScale.gray100}`};
  ${DESKTOP} {
    height: 60px;
  }
`;

export const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 328px;
  height: inherit;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${lnbAndFloating} {
    padding: 0 108px;
    max-width: 1440px;
  }
`;

export const Image = styled.div`
  width: 85px;
  height: 32px;
`;

export const Empty = styled.div``;
